// дублируем EActiveView из виджета авторизации, импорт enum напрямую из виджета потянет за собой большой бандл
export enum EActiveView {
  PhoneAuth = 'phoneAuth',
  PhoneAuthValidateSms = 'phoneAuthValidateSms',
  PhoneAuthValidateCall = 'phoneAuthValidateCall',
  AccountSelect = 'accountSelect',
  ConfirmSelectedAccount = 'confirmSelectedAccount',
  AccountSelectError = 'accountSelectError',
  TokenExpiredError = 'tokenExpiredError',
  AuthenticationRegistration = 'authenticationRegistration',
  Agreement = 'agreement',
  SocialCreate = 'socialCreate',
  SocialMerge = 'socialMerge',
  TwoFactor = 'twoFactor',
  TwoFactorWithEmail = 'twoFactorWithEmail',
  TwoFactorAttemptsExhausted = 'twoFactorAttemptsExhausted',
  Restore = 'restore',
  ConfirmPhone = 'confirmPhone',
  EmailSent = 'emailSent',
  RememberedAccountsSelect = 'rememberedAccountsSelect',
}
